export const DOWNLOAD_LOG_REQUEST = 'DOWNLOAD_LOG_REQUEST';
export const DOWNLOAD_LOG_SUCCESS = 'DOWNLOAD_LOG_SUCCESS';
export const DOWNLOAD_LOG_FAILURE = 'DOWNLOAD_LOG_FAILURE';

export const downloadLogRequest = (date) => ({ type: DOWNLOAD_LOG_REQUEST, date });
export const downloadLogSuccess = (blob) => ({ type: DOWNLOAD_LOG_SUCCESS, blob });
export const downloadLogFailure = (error) => ({ type: DOWNLOAD_LOG_FAILURE, error });
